import React, { useState, useEffect } from 'react'
import SbEditable from 'storyblok-react'
import Headline from '../atoms/Headline'
import Modal from 'react-modal'
import { Helmet } from 'react-helmet'
import Video from '../atoms/Video'

const VideoListBlock = ({ block }) => {
  const [modalIsOpen, setIsOpen] = useState(false)
  const [currentItem, setCurrentItem] = useState(null)

  const openModal = () => {
    //e.preventDefault()
    setIsOpen(true)
  }
  const closeModal = () => {
    //e.preventDefault()
    setIsOpen(false)
  }

  useEffect(() => {
    return () => {
      setCurrentItem(null)
      setIsOpen(false)
    }
  }, [])
  return (
    <SbEditable content={block}>
      <section className="video-list-block">
        <div className="video-list-block-container">
          <div className="video-list-block-wrapper">
            <div>
              <Headline
                kicker={block.kicker}
                headline={block.headline}
                subheadline={block.subheadline}
                headline_level="h2"
                tagName="h2"
              />
            </div>
            <div className="row">
              {block.video_list_items?.length > 0 &&
                block.video_list_items.map((item, index) => (
                  <div className="mb-2 col-12 col-sm-6 col-md-4">
                    <button
                      className="btn btn-primary me-1"
                      onClick={() => {
                        setCurrentItem(item)
                        openModal()
                      }}
                    >
                      <i className="fas fa-play me-1"></i>
                      {item.link_text}
                    </button>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      {currentItem !== null && (
        <Modal
          isOpen={modalIsOpen && currentItem !== null}
          onRequestClose={() => closeModal()}
          style={{
            overlay: {
              backgroundColor: 'rgba(0,0,0,.5)',
              zIndex: '1060',
              cursor: 'pointer',
            },
            content: {
              background: 'transparent',
              border: 'none',
              inset: '0',
              padding: '1.5rem',
              pointerEvents: 'none',
            },
          }}
          shouldCloseOnOverlayClick={true}
        >
          <Helmet bodyAttributes={{ class: 'overflow-hidden' }} />
          <div className="modal-inner">
            <div className="modal-header">
              <h4 className="modal-title" id="spa-modal-label">
                {currentItem?.link_text}
              </h4>
              <input
                className="btn btn-close"
                type="button"
                value=""
                onClick={(e) => closeModal(e)}
              />
            </div>
            <div className="modal-body">
              <div className="figmedia">
                <Video
                  video={currentItem?.video_url + '?badge=0&autoplay=1&html5=1'}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </SbEditable>
  )
}

export default VideoListBlock
